import styled from 'styled-components';

export const FlashMessageContainerWrapper = styled.section`
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
`;
